import {
  PropsWithChildren,
  useMemo,
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
} from 'react';
import { Assignee } from './Assignees';
import { useAssignees } from './useAssignees';

export type AssigneesContextType = {
  assignees: Assignee[],
  setAssigneesData: Dispatch<SetStateAction<Assignee[]>>,
  fetchAssignees(): Promise<void>,
}

const defaultAssigneesContext: AssigneesContextType = {
  assignees: [],
  setAssigneesData: () => {},
  fetchAssignees: async () => {},
};

export const AssigneesContext = createContext<AssigneesContextType>(
  defaultAssigneesContext,
);

export function useAssigneesContext() {
  return useContext(AssigneesContext);
}

export function AssigneesProvider({ children }: PropsWithChildren) {
  const assignees = useAssignees();

  const contextValue = useMemo(() => ({ ...assignees }), [assignees]);

  return (
    <AssigneesContext.Provider value={contextValue}>
      {children}
    </AssigneesContext.Provider>
  );
}
